import { deleteCookie, getCookie_base64, initializeTooltips } from "../../util/general_util"
import { Trip_Cluster_v2, Trip_leg_v2 } from "../../util/tripPlanner_types";
import { deleteCachedTrip, update_interests } from "../api_utils"
import { genieWishes_submit_initial, get_stop_from_stopID } from "../util/helper_functions";
import { getTripTips } from "../wishes_scripts";

export function init_tripAction_listeners() {
    $("#abandonTrip").on("click", () => {
        deleteCachedTrip(getCookie_base64("trip")).then(() => {
            deleteCookie("trip", "", window.location.hostname);

            window.history.replaceState({}, document.title, "/tripPlanner");
            window.location.reload();
        }).catch(e => {
            deleteCookie("trip", "", window.location.hostname);
            if (window.location.toString().includes("id=")) {
                window.history.replaceState({}, document.title, "/tripPlanner");
            };
            window.location.reload();
        });
    });

    $("#stopWishesForm").on("submit", function(event) {
        event.preventDefault();
        const form:HTMLFormElement = this as HTMLFormElement;
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        };

        const stopID = form.getAttribute("stopID");
        const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);
        if (stopData == null) return;
        const stop = stopData.stop;
        const legIndex = stopData.legIndex;
        const stopIndex = stopData.stopIndex;

        const formData = genieWishes_submit_initial(form);
        const userInterests_resp = formData.userInterests_resp;
        const whatToDo_resp = formData.whatToDo_resp;

        const save_interests_check = $(form).find("[save-interests]");
        if ( save_interests_check.prop("checked") ) {
            update_interests(whatToDo_resp);
            $("#userInterests-edit-input").val(whatToDo_resp);
            $("[userInterests]").val(whatToDo_resp);
            $("[userInterests_disp]").html(whatToDo_resp);
            $("[use-interests-wrap]").removeClass("d-none");
            $("[save-interests-wrap]").addClass("d-none");
            save_interests_check.prop("checked",false);
        };

        const tripStops:Array<{title:string,stopID:string,coords:{latitude:number,longitude:number}}> = [];
        if (stop.geo_query !== undefined && stop.geo_query.length) {
            tripStops.push({
                title: stop.geo_query,
                stopID:stop.stopID,
                coords: stop.coords
            });
        } else {
            tripStops.push({
                title: stop.clusterTitle,
                stopID:stop.stopID,
                coords: stop.coords
            });
        };

        $("#stop-wishes-results-query-disp").html(`"${whatToDo_resp}"`);

        $("#stop-wishes-loading").removeClass("d-none");
        $("#stop-wishes-input").hide();
        $("#stop-wishes-results").show();

        const is_suggested_stop = !stop.fromUserQuery;

        getTripTips(
            window.tripPlannerCurrentTrip,
            "#singleStopWishesOutput",
            tripStops,
            userInterests_resp,
            whatToDo_resp,
            is_suggested_stop
        ).then(() => {
            $(form).find("[use-interests]").prop("disabled",false);
            $(form).find("[whatToDo]").prop("disabled",false);
            $(form).find('button[type="submit"]').removeClass("disabled");

            $("#stop-wishes-loading").addClass("d-none");

            initializeTooltips();
        }).catch(e => {
            console.error(e);
            $(form).find("[wishesErrMsg]").html(e.message);
            $(form).find("[use-interests]").prop("disabled",false);
            $(form).find("[whatToDo]").prop("disabled",false);
            $(form).find('button[type="submit"]').removeClass("disabled");
            $("#stop-wishes-loading").addClass("d-none");
        });
    });

    $("#getItineraryForm").on("submit", function(event) {
        event.preventDefault();
        const form:HTMLFormElement = this as HTMLFormElement;
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        };

        const formData = genieWishes_submit_initial(form);
        const userInterests_resp = formData.userInterests_resp;
        const whatToDo_resp = formData.whatToDo_resp;

        const save_interests_check = $(form).find("[save-interests]");
        if ( save_interests_check.prop("checked") ) {
            update_interests(whatToDo_resp);
            $("#userInterests-edit-input").val(whatToDo_resp);
            $("[userInterests]").val(whatToDo_resp);
            $("[userInterests_disp]").html(whatToDo_resp);
            $("[use-interests-wrap]").removeClass("d-none");
            $("[save-interests-wrap]").addClass("d-none");
            save_interests_check.prop("checked",false);
        };

        const tripStops:Array<{title:string,stopID:string,coords:{latitude:number,longitude:number}}> = [];

        for (let i:number = 0; i < window.tripPlannerCurrentTrip.legs.length; i++) {
            for (let j:number = 0; j < window.tripPlannerCurrentTrip.legs[i].clusters.length; j++) {
                const cluster:Trip_Cluster_v2 = window.tripPlannerCurrentTrip.legs[i].clusters[j];
                // if (!cluster.fromUserQuery) continue;
                if (cluster.geo_query !== undefined && cluster.geo_query.length) {
                    tripStops.push({
                        title:cluster.geo_query,
                        stopID: cluster.stopID,
                        coords: cluster.coords
                    });
                } else {
                    tripStops.push({
                        title:cluster.clusterTitle,
                        stopID: cluster.stopID,
                        coords: cluster.coords
                    });
                }
            };
        };

        // $("#postSearchText").removeClass("d-none");
        if (!$("#addAllWishes").hasClass("d-none")) $("#addAllWishes").addClass("d-none");

        $("#trip-wishes-results-query-disp").html(`"${whatToDo_resp}"`);

        $("#trip-wishes-loading").removeClass("d-none");

        $("#trip-wishes-input").hide();
        $("#trip-wishes-results").show();

        $(form).find('button[type="submit"]').addClass("disabled");

        getTripTips(
            window.tripPlannerCurrentTrip,
            "#wholeTripWishesOutput",
            tripStops,
            userInterests_resp,
            whatToDo_resp,
            false
        ).then(() => {
            $(form).find("[use-interests]").prop("disabled",false);
            $(form).find("[whatToDo]").prop("disabled",false);
            // $(form).find('button[type="submit"]').removeClass("disabled");

            $("#trip-wishes-loading").addClass("d-none");
            $("#addAllWishes").removeClass("d-none");

            initializeTooltips();
        }).catch(e => {
            console.error(e);
            $("#postSearchText").addClass("d-none");
            $(form).find("[wishesErrMsg]").html(e.message);
            $(form).find("[use-interests]").prop("disabled",false);
            $(form).find("[whatToDo]").prop("disabled",false);
            $(form).find('button[type="submit"]').removeClass("disabled");
            $("#trip-wishes-loading").addClass("d-none");
        });
    });
}